export enum DealStatus {
  QUOTE_RECEIVED = 'QUOTE_RECEIVED',
  APPOINTMENT_PENDING = 'APPOINTMENT_PENDING',
  APPOINTMENT_BOOKED = 'APPOINTMENT_BOOKED',
  OFFER_RECEIVED = 'OFFER_RECEIVED',
  OFFER_ACCEPTED = 'OFFER_ACCEPTED'
}
